import React from "react";
import {
  InlineTypeahead,
  InlineTypeaheadProps,
} from "~/components/inline-typeahead";
import { EogAfeTypeMutationInput, EogAfeType } from "~/gql/types";
import { useEogAfeTypeValuesAsync } from "~/refdata2/eogAfeTypeValues";

const format = (item: EogAfeType): React.ReactNode =>
  `${item.afeType} - ${item.gen} - ${item.sub} - ${item.description}`;

type InlineEogAfeTypePickerProps = {
  name: string;
  value: EogAfeTypeMutationInput;
  onChange: (val: EogAfeTypeMutationInput | null) => void;
  onBlur?: React.FocusEventHandler<any>;
  required?: boolean;
  submitError?: string;
};

export const InlineEogAfeTypePicker: React.FC<InlineEogAfeTypePickerProps> = (
  props
) => {
  const getEogAfeTypeValues = useEogAfeTypeValuesAsync();

  const getData = async (searchText: string) => {
    const result = (await getEogAfeTypeValues()) ?? [];

    if (!searchText) {
      return result;
    }

    return result.filter(
      (g) =>
        g.description.toLowerCase().includes(searchText) ||
        g.gen.toLowerCase().includes(searchText) ||
        g.sub.toLowerCase().includes(searchText) ||
        g.afeType.toLowerCase().includes(searchText)
    );
  };

  const args = {
    ...props,
    getData,
    format,
  } as InlineTypeaheadProps<EogAfeType>;

  return (
    <div className="inline-service-description-picker">
      <InlineTypeahead {...args} />
    </div>
  );
};
